import { useEffect, useRef } from 'react';

type CleanupFn = () => void;

// Как useEffect, но выполняется синхронно (а не после рендера)
export function useImmediateEffect(fn: () => CleanupFn | void, deps: unknown[]) {
  const depsRef = useRef<unknown[] | undefined>(undefined);
  const cleanupRef = useRef<CleanupFn | void>(undefined);

  if (!depsRef.current || !dependencyEqual(deps, depsRef.current)) {
    cleanupRef.current?.();

    const nextCleanUp = fn();
    cleanupRef.current = nextCleanUp;
  }
  depsRef.current = deps;

  useEffect(() => {
    return () => {
      cleanupRef.current?.();
    };
  }, []);
}

function dependencyEqual(arrA: unknown[], arrB: unknown[]): boolean {
  if (arrA === arrB) return true;
  if (arrA.length !== arrB.length) return false;
  for (let i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) return false;
  }
  return true;
}
